import React from 'react';

import FieldBold from '../../Fields/FieldBold/FieldBold';
import Tags from '../../Tags/Tags';
import { ReactComponent as Trash } from '../../../assets/icons/Trash.svg';
import { ReactComponent as CircleExclamation } from '../../../assets/icons/CircleExclamation.svg';
import Button from '../../Buttons/Button/Button';
import CheckboxLabel from '../../inputs/Checkboxes/CheckboxLabel/CheckboxLabel';
import { sourceIconAccountsObject } from '../../../store/catalogs/banks';
import Tooltip from '../../Tooltip/Tooltip';
import NoticeCard from '../../NoticeCard/NoticeCard';

import classes from './CardBank.module.scss';
import { statusAccountDestination, statusAccountOrigin } from '../../../store/constants/statusDruoAccounts';

/* const statusAccount = {
  SUCCESS: {
    color: 'green',
    tooltip: 'La información de la cuenta bancaria se validó. Ya puedes realizar pagos a esta cuenta.'
  },
  ERROR: {
    color: 'failed',
    tooltip: 'No se logró hacer la conexión con esta cuenta. '
  },
  PROCESSING: {
    color: 'orange',
    tooltip: 'La información de la cuenta bancaria se encuentra en proceso de verificación.'
  }
}; */

const CardBank = ({
  idx,
  businessName,
  bankId,
  subtypeLabel,
  bankLast4Digits,
  identificationTypeLabel,
  identificationNumber,
  status,
  druoStatusDescription,
  deleteAccount,
  druoAccountId,
  origin,
  isDefault = false,
  onSetDefault
}) => {
  const statusAccount = origin ? statusAccountOrigin : statusAccountDestination;
  const iconBank = sourceIconAccountsObject[bankId];

  const handleDefaultChange = () => {
    if (!isDefault && onSetDefault) {
      onSetDefault();
    }
  };

  return (
    <div key={idx} className={`${classes.card}`}>
      {onSetDefault && (
        <div className={classes.header}>
          <CheckboxLabel
            id={`default-${druoAccountId}`}
            name={`default-${druoAccountId}`}
            checked={isDefault}
            onClick={handleDefaultChange}
            label='Cuenta predeterminada'
          />
        </div>
      )}
      <div className={classes.up}>
        <div className={classes.fields}>
          <FieldBold name={`${bankId}-${idx}`} title={'Banco'}>
            {iconBank}
          </FieldBold>
          <FieldBold name={`${subtypeLabel}-${idx}`} title={'Tipo de cuenta'} value={subtypeLabel} />
          <FieldBold name={`${bankLast4Digits}-${idx}`} title={'Últimos 4 dígitos'} value={`...${bankLast4Digits}`} />
          <FieldBold name={`${status}-${idx}`} title={'Estado'}>
            <div className={classes.status}>
              <Tags text={statusAccount[status]?.label} type={statusAccount[status]?.color} />
              <Tooltip type='info' content={statusAccount[status]?.tooltip}>
                <CircleExclamation />
              </Tooltip>
            </div>
          </FieldBold>
          <FieldBold
            name={`${identificationTypeLabel}-${idx}`}
            title={'Documento del propietario'}
            value={`${identificationTypeLabel} - ${identificationNumber}`}
          />
        </div>
        <div className={classes.buttons}>
          <Button onClick={() => deleteAccount(druoAccountId)} custom='quaternary' color='gray' Icon={Trash}>
            Eliminar
          </Button>
        </div>
      </div>
      {status === 'ERROR' && (
        <NoticeCard
          className={classes.notice}
          type='failed'
          text={`No pudimos conectar la cuenta bancaria de ${businessName}. Verifica la información ingresada. Si los datos están correctos, el proveedor debe verificar la autorización con su banco. Si el error persiste, contacta a soporte técnico.`}
        />
      )}
    </div>
  );
};

export default CardBank;
